var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Interface } from 'ethers/lib/utils';
import { Config } from '../../../../Fct/Config';
import ParaswapAugustusSwapperABI from '../../../../abis/paraswap_augustus_swapper.json';
import { Paraswap } from '../Paraswap';
var API_URL = 'https://apiv5.paraswap.io';
var REJECT_PREV_REQUEST_ERROR = 'reject previous values';
var ParaswapHelper = /** @class */ (function (_super) {
    __extends(ParaswapHelper, _super);
    function ParaswapHelper() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.promiseReject = undefined;
        _this.getSwapParams = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var values, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getSwap(params)];
                    case 1:
                        values = _a.sent();
                        return [2 /*return*/, values];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 === REJECT_PREV_REQUEST_ERROR) {
                            return [2 /*return*/, undefined];
                        }
                        throw new Error(e_1);
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.getSwap = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var _b;
                return __generator(this, function (_c) {
                    (_b = this.promiseReject) === null || _b === void 0 ? void 0 : _b.call(this, REJECT_PREV_REQUEST_ERROR);
                    return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var networkId, isExactIn, amount, queryParams, searchString, pricesURL, data, priceRoute, txURL, txConfig, txData, txDataJson, IParaswapSwapper, decodedTx, err_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.promiseReject = reject;
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 6, , 7]);
                                        networkId = this.chainId.toString();
                                        isExactIn = Boolean(input.amount);
                                        if (!isExactIn && !output.amount) {
                                            throw new Error('Amount is missing');
                                        }
                                        amount = (isExactIn ? input.amount : output.amount);
                                        queryParams = {
                                            srcToken: input.currency.address,
                                            destToken: output.currency.address,
                                            srcDecimals: input.currency.decimals.toString(),
                                            destDecimals: output.currency.decimals.toString(),
                                            amount: amount,
                                            side: isExactIn ? 'SELL' : 'BUY',
                                            network: this.chainId.toString(),
                                        };
                                        searchString = new URLSearchParams(queryParams);
                                        pricesURL = "".concat(API_URL, "/prices/?").concat(searchString);
                                        return [4 /*yield*/, fetch(pricesURL)];
                                    case 2:
                                        data = _a.sent();
                                        return [4 /*yield*/, data.json()];
                                    case 3:
                                        priceRoute = (_a.sent()).priceRoute;
                                        txURL = "".concat(API_URL, "/transactions/").concat(networkId, "?ignoreChecks=true");
                                        txConfig = {
                                            priceRoute: priceRoute,
                                            srcToken: queryParams.srcToken,
                                            srcDecimals: queryParams.srcDecimals,
                                            destToken: queryParams.destToken,
                                            destDecimals: queryParams.destDecimals,
                                            srcAmount: priceRoute.srcAmount,
                                            destAmount: priceRoute.destAmount,
                                            userAddress: this.account,
                                        };
                                        return [4 /*yield*/, fetch(txURL, {
                                                method: 'POST',
                                                body: JSON.stringify(txConfig),
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                            })];
                                    case 4:
                                        txData = _a.sent();
                                        return [4 /*yield*/, txData.json()];
                                    case 5:
                                        txDataJson = (_a.sent());
                                        IParaswapSwapper = new Interface(ParaswapAugustusSwapperABI);
                                        decodedTx = IParaswapSwapper.parseTransaction({ data: txDataJson.data, value: txDataJson.value });
                                        resolve({
                                            params: {
                                                value: txDataJson.value,
                                                methodParams: Object.entries(decodedTx.args).reduce(function (acc, _a) {
                                                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                                    if (key === 'pools') {
                                                        if (Array.isArray(value)) {
                                                            acc[key] = value.map(function (val) { return val.toString(); });
                                                        }
                                                        else {
                                                            acc[key] = [value.toString()];
                                                        }
                                                    }
                                                    else {
                                                        acc[key] = value.toString();
                                                    }
                                                    return acc;
                                                }, {}),
                                            },
                                            state: 'VALID',
                                            methodName: decodedTx.name,
                                            plugin: this.getParaswapPlugin(decodedTx.name),
                                            inputAmount: priceRoute.srcAmount,
                                            outputAmount: priceRoute.destAmount,
                                            protocol: 'PARASWAP',
                                        });
                                        return [3 /*break*/, 7];
                                    case 6:
                                        err_1 = _a.sent();
                                        reject(err_1);
                                        return [3 /*break*/, 7];
                                    case 7: return [2 /*return*/];
                                }
                            });
                        }); })];
                });
            });
        };
        _this.getParaswapPlugin = function (methodName) {
            var plugin = Object.values(Paraswap.actions).find(function (plugin) {
                var pluginInit = new plugin({ chainId: '1' });
                return pluginInit.method === methodName;
            });
            return plugin;
        };
        return _this;
    }
    return ParaswapHelper;
}(Config));
export { ParaswapHelper };
